import React from 'react';
import { RsIcon } from './roomShellStyle';
import { PANELS } from '../../utils/roomPanels';

// 📱 The phone bar (mockup frame A, phone): [Chat] [Tools +] [Files] [People],
// safe-area padded. Chat and Tools are fixed; the rest is GENERATED from the
// panel registry (rows with phoneBar: true that the page can draw), so the bar,
// the sheets and the registry can never disagree (§5.2: this kills the old
// places nav's "3-enum trap").
//
//   active     'chat' | 'tools' | a panel id: which one is up
//   available  Set of panel ids the page can draw
//   onSelect   ('chat' | 'tools' | panelId) => void

export function phoneBarItems(available) {
  const have = available instanceof Set ? available : new Set(available || []);
  return [
    { id: 'chat', label: 'Chat', icon: 'chat' },
    { id: 'tools', label: 'Tools', icon: 'plus' },
    ...PANELS.filter((p) => p.phoneBar && have.has(p.id)).map((p) => ({ id: p.id, label: p.label, icon: p.icon })),
  ];
}

export default function RoomShellPhoneBar({ active = 'chat', available, onSelect }) {
  const items = phoneBarItems(available);
  return (
    // a div with role="navigation", never <nav>: stored room themes paint `nav` (one with
    // `background: … !important`, which no class rule can beat)
    <div className="rs-phbar" role="navigation" data-rs-phbar="" aria-label="Room">
      {items.map((it) => (
        <button
          key={it.id}
          type="button"
          className="rs-phb"
          data-prop-ui=""
          data-rs-phb={it.id}
          aria-pressed={active === it.id}
          onClick={() => onSelect && onSelect(it.id)}
        >
          <RsIcon name={it.icon} size={20} stroke={it.id === 'tools' ? 2.4 : 2} />
          <span>{it.label}</span>
        </button>
      ))}
    </div>
  );
}
